export interface BlogPost {
  id: number;
  title: string;          
  titleHtml: string;      
  contentHtml: string;    
  excerptHtml: string; 
  slug: string;
  link: string;
  date: Date;
  modified: Date;
  authorId: number;
  authorName?: string;
  authorAvatar?: string;
  featuredMediaId: number;
  featuredMediaUrl?: string;
  categories: number[];
  categoryNames?: string[];
  tags: number[];
  status: string;
  format: string;
  isSticky: boolean;
  commentStatus: 'open' | 'closed';
}

export function mapWPPost(post: any): BlogPost {
  const embedded = post._embedded || {};
  
  // Extract featured image
  const featuredMedia = embedded['wp:featuredmedia']?.[0];
  const featuredMediaUrl =
    featuredMedia?.source_url ||
    featuredMedia?.media_details?.sizes?.full?.source_url ||
    featuredMedia?.media_details?.sizes?.large?.source_url ||
    featuredMedia?.guid?.rendered ||
    '';

  // Extract author
  const author = embedded['author']?.[0];
  const authorName = author?.name || 'Baoafrik Team';
  const authorAvatar = author?.avatar_urls?.['96'] || author?.avatar_urls?.['48'] || '';

  // Extract category names
  const categoryTerms = (embedded['wp:term']?.[0] || []).filter((term: any) => term.taxonomy === 'category');
  const categoryNames = categoryTerms.map((term: any) => term.name);

  return {
    id: post.id,

    // Title
    title: decodeHtml(post.title?.rendered || ''),
    titleHtml: post.title?.rendered || '',

    // Content
    contentHtml: post.content?.rendered || '',
    excerptHtml: post.excerpt?.rendered || '',

    // Routing
    slug: post.slug,
    link: post.link,

    // Dates
    date: new Date(post.date),
    modified: new Date(post.modified),

    // Meta
    authorId: post.author,
    authorName,
    authorAvatar,
    
    featuredMediaId: post.featured_media,
    featuredMediaUrl,

    categories: post.categories || [],
    categoryNames,
    tags: post.tags || [],

    status: post.status,
    format: post.format,

    isSticky: post.sticky,
    commentStatus: post.comment_status,
  };
}

function decodeHtml(html: string): string {
  if (typeof window === 'undefined') return html;

  const txt = document.createElement('textarea');
  txt.innerHTML = html;
  return txt.value;
}